import React from 'react';
import PropTypes from 'prop-types';

import { Conditional, Popup, Text } from '@cashfree-intl/coherent';

const CombinedModesNote = ({ combinedModes, inline = true }) =>
  combinedModes.length > 0 ? (
    <Text className="combined-group-note">
      <span className="font-bolder mr-1">Note:</span>
      <Conditional if={combinedModes.length <= 2}>
        {combinedModes.map(obj => obj.display).join(' and ')} will also be
        enabled upon submission.
      </Conditional>
      {combinedModes.length > 2 && (
        <>
          {combinedModes
            .slice(0, 2)
            .map(obj => obj.display)
            .join(', ')}{' '}
          and {!inline ? <br /> : ''}
          <Popup
            position={inline ? 'bottom right' : 'bottom left'}
            content={() =>
              combinedModes.slice(2).map(obj => (
                <Text key={obj.display} variant="b12" color="bodyLight">
                  {obj.display}
                </Text>
              ))
            }
            trigger={
              <span className="text-primary pointer">
                {combinedModes.length - 2} more
              </span>
            }
          />{' '}
          will also be enabled upon submission.
        </>
      )}
    </Text>
  ) : null;

CombinedModesNote.propTypes = {
  combinedModes: PropTypes.array,
  inline: PropTypes.bool,
};

export default CombinedModesNote;
